import { getPrefixedLogger, prefixes } from './rwc-logger';

const logger = getPrefixedLogger(prefixes.VC_UTILS, 'dom');

const copyToClipboardLegacy = (textToCopy: string): void => {
    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.setSelectionRange(0, 999999);
    document.execCommand('copy');
    document.body.removeChild(textarea);
};

const permissionsCheck = new Map<PermissionName, boolean>();

async function checkPermissionAvailable(name: PermissionName): Promise<boolean> {
    if (!('permissions' in navigator)) return false;
    if (permissionsCheck.has(name)) return permissionsCheck.get(name)!;
    let result = true;
    try {
        await navigator.permissions.query({ name });
    } catch (error) {
        result = false;
    }
    permissionsCheck.set(name, result);
    return result;
}

export const copyToClipboard = async (textToCopy: string): Promise<void> => {
    try {
        let clipboardWritePermission = { state: 'granted' };
        if (await checkPermissionAvailable('clipboard-write' as PermissionName))
            clipboardWritePermission = await navigator.permissions?.query({
                name: 'clipboard-write' as PermissionName,
            });

        if (navigator.clipboard && clipboardWritePermission.state === 'granted') {
            await navigator.clipboard.writeText(textToCopy);
        } else {
            copyToClipboardLegacy(textToCopy);
        }
        logger.debug(`${textToCopy} has been copied to clipboard`);
        // TODO: RCV-99509 fix ts after update ts
    } catch (error: any) {
        logger.warn('clipboard is unavailabe', error);
        return Promise.reject(error);
    }
};
